import { render, staticRenderFns } from "./modifypwd.vue?vue&type=template&id=07dba7b4&scoped=true&"
import script from "./modifypwd.vue?vue&type=script&lang=js&"
export * from "./modifypwd.vue?vue&type=script&lang=js&"
import style0 from "./modifypwd.vue?vue&type=style&index=0&id=07dba7b4&prod&lang=scss&"
import style1 from "./modifypwd.vue?vue&type=style&index=1&id=07dba7b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dba7b4",
  null
  
)

export default component.exports